import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { presetRequest } from "./QuoteSection";

const SERVICES = [
  "Product sourcing",
  "Supplier identification & due diligence",
  "Commercial procurement support",
  "Recurring supply coordination",
  "Multi-location procurement",
  "Delivery coordination",
  "Documentation management",
];

const AUDIENCE = [
  "International companies entering Nigeria",
  "International contractors",
  "Global logistics companies",
  "International energy & industrial companies",
  "Aviation operators",
];

export default function InternationalSection() {
  return (
    <section id="international" data-testid="international-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_20%,rgba(0,229,255,0.05),transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14">
        <Reveal>
          <SectionTag number="11" label="International" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white">
            Need energy procurement <span className="text-gold">in Nigeria?</span>
          </h2>
          <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed max-w-lg">
            Entering or operating in the Nigerian market can make local energy procurement
            difficult. Ajemi helps businesses navigate sourcing, supplier relationships and
            recurring petroleum procurement through a structured procurement process —
            connecting international businesses to reliable energy procurement in Nigeria.
          </p>
          <div className="mt-8 space-y-3" data-testid="international-audience">
            {AUDIENCE.map((a) => (
              <div key={a} className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
                <span className="text-sm text-white/60">{a}</span>
              </div>
            ))}
          </div>
          <button
            data-testid="international-team-btn"
            onClick={() => presetRequest({ type: "one_time", note: "International procurement support enquiry" })}
            className="group mt-10 inline-flex items-center gap-3 bg-gold text-ink font-outfit font-medium rounded-full pl-7 pr-2.5 py-2.5 hover:bg-goldbright hover:shadow-[0_0_40px_rgba(217,164,65,0.45)] transition-all duration-300"
          >
            Talk to Ajemi
            <span className="bg-ink/10 rounded-full p-2 group-hover:rotate-45 transition-transform duration-300">
              <ArrowUpRight className="w-4 h-4" />
            </span>
          </button>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="glass-panel rounded-2xl p-8 md:p-10" data-testid="international-services-card">
            <p className="text-[11px] tracking-[0.35em] uppercase text-white/40 mb-7">
              International Procurement Services
            </p>
            <div className="space-y-4">
              {SERVICES.map((s) => (
                <div key={s} className="flex items-center gap-3">
                  <span className="w-5 h-5 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center shrink-0">
                    <Check className="w-3 h-3 text-gold" />
                  </span>
                  <span className="text-sm text-white/70">{s}</span>
                </div>
              ))}
            </div>
            <p className="text-white/35 text-xs leading-relaxed mt-8 border-t border-white/8 pt-6">
              International transactions are structured case by case, subject to the appropriate
              licences, approvals and transaction requirements of the relevant parties.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
